module.exports = __webpack_public_path__ + "65e7da800d02c959d34767b89a8bb36d.pdf";